{
  "buttons": {
    "newMicropost": "New Post"
  },
  "audienceLabel": {
    "custom": "Custom Audience",
    "everyone": "Everyone",
    "everyoneAllSeasons": "Everyone All Seasons",
    "gender": {
      "singular": "gender",
      "plural": "genders"
    },
    "division": {
      "singular": "division",
      "plural": "divisions"
    },
    "session": {
      "singular": "session",
      "plural": "sessions"
    },
    "bunkPlanSuffix": {
      "singular": "plan",
      "plural": "plans"
    }
  }
}
